import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Attachement, CityDropdownForTrip, CommonCityStateDropdown, CommonInput, CommonModal, CrossButton, CustomSelect } from 'components'
import { errorSchema, utils } from 'helper';
import { State } from "country-state-city";
import StorageService from "utils/StorageServices/StorageServices";
import { UserContext } from "context";
import toast from 'react-hot-toast';
import { createConsignor, getAllConsignorgGroup, getConsignorListData } from '_services/accountsServices/consignorServices';
import { AddButton } from 'components/common/CommonButton';
import { constant } from 'constants/constant';
import { createSupplier, deleteImage, editSupplier } from '_services/accountsServices/supplierServices';
import { getDashbordData, getLanguageData, getStatesData, handleKeyDown, uploadFiles } from '_services';
import { FaRegTrashAlt } from "react-icons/fa";
import { getCityLocationList } from '_services/accountsServices/cityLocationService';
import AddLocationModal from 'modals/AddLocationModal';
import { IoCloseCircle } from 'react-icons/io5';
import ImageCropModal from 'components/ImageModify/ImageCropModal';
import ImageCropperModal from 'components/ImageModify/ImageNewCropper/ImageCropperModal';
import { BsFiletypeXlsx, BsFillFileEarmarkPdfFill } from 'react-icons/bs';
import { FaRegImage } from 'react-icons/fa6';
import { MdOutlineFileDownload, MdOutlineRemoveRedEye } from 'react-icons/md';
import { RxCross2 } from 'react-icons/rx';
import FirmImg from '../../assets/img/firm.png'
import { getFirm, getUserFirm } from '_services/accountsServices/firmServices';
import { Link } from 'react-router-dom';
import ImagePreview from 'modals/LrDetailModal/ImagePreview';
import { FaYoutube } from 'react-icons/fa6';
import YoutubeModal from 'modals/YoutubeModal';

const getFormattedDate = (is_date = '') => {
    const today = is_date ? new Date(is_date) : new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

const formObj = {
    company_id: StorageService.getCompanyId(),
    name: '',
    contact_no: '',
    opening_balance: '',
    pay_type: 2,
    as_of_date: getFormattedDate(),
    address_line1: '',
    state: {},
    city: {},
    pincode: '',
    email_id: '',
    alt_contact_no: '',
    gst_no: '',
    gst_treatment_id: {},
    gst_state: {},
    tds_declaration_form: [],
    tds_deduction: {},
    pan_image: "",
    message_lang: { label: "हिन्दी", value: 'hi' },
    firm_id: {},
}

const AddEditSupplier = ({ isOpen, onClose, callBackSupplier, branchFirmId, hideAddNewOption = true }) => {

    const { masterData, cities, states, setStates, youtubeVideos, setYoutubeVideos } = useContext(UserContext)

    const [formValue, setFormValue] = useState(formObj);
    const [formError, setFormError] = useState({});
    const [loading, setLoading] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [stateValue, setStateValue] = useState({});
    const [openLoction, setOpenLoction] = useState(false)
    const [attachments, setAttachments] = useState([]);
    const [panAttacthment, setPanAttacthment] = useState({});
    const [isAttachement, setIsAttachement] = useState(false);
    const [isTds, setIsTds] = useState(false);
    const [isDelete, setIsDelete] = useState(false);

    const [canPanImageEmpty, setCanPanImageEmpty] = useState(false);

    const [languageArray, setLanguageArray] = useState([]);

    const [firmDataList, setFirmDataList] = useState([]);

    const [imagePreview, setImagePreview] = useState({})

    const [activeTab, setActiveTab] = useState(1);
    // Add and New Button functionality
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [userData, setUserData] = useState('')
    const companydetails = userData?.user_detail?.company_list?.find((i) => i?.company_id?._id === StorageService?.getCompanyId())

    const panPermission = companydetails?.company_id?.perms_supplier

    const [croppedImage, setCroppedImage] = useState(null);
    const [imageLoading, setImageLoading] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [originalImage, setOriginalImage] = useState(
        null
    );
    const [image, setImage] = useState(null);
    const [crop, setCrop] = useState({
        unit: 'px',
        x: 50,
        y: 50,
        width: 200,
        height: 200
    });
    const [zoom, setZoom] = useState(1);
    const [rotation, setRotation] = useState(0);
    const [completedCrop, setCompletedCrop] = useState(null);
    const [showPreview, setShowPreview] = useState(true);
    const [previewImage, setPreviewImage] = useState(null);

    const fetchFromCity = async (search, page, limit) => {
        const res = await getCityLocationList({
            countryCode: "IN",
            stateCode: "",
            offset: page,
            limit,
            search,

        });
        if (res?.responseCode === 200) {
            const list = res?.data?.all_cities.map((c) => ({ ...c, value: c.name, label: c.name }))

            return {

                items: [...list],

                total: res?.data?.total_record,
            };

        } else {
            toast.error(res?.responseMessage);
        }
    };


    const handleOnChange = async (name, value) => {
        const stateObj = { ...formValue, [name]: value };
        if (name === "gst_no") {
            let gstCode = parseInt(value.slice(0, 2), 10);
            stateObj['gst_state'] = utils.codeToStateNameObject[gstCode];
        }
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.addSupplierSchema);
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const apiCallingFunction = async (shouldCloseModal) => {
        try {
            if (isOpen?._id) {
                let object = {
                    ...formValue,
                    firm_id: formValue?.firm_id?.value ? formValue?.firm_id?.value : '',
                    message_lang: formValue?.message_lang?.value,
                    supplier_id: isOpen?._id,
                    contact_no: formValue?.contact_no != null ? formValue?.contact_no : '',
                    pincode: formValue?.pincode != null ? formValue?.pincode : '',
                    alt_contact_no: formValue?.alt_contact_no != null ? formValue?.alt_contact_no : '',
                    tds_deduction: isTds ? formValue?.tds_deduction?.value : 0,
                    gst_treatment_id: formValue?.gst_treatment_id?.value,
                    gst_state: {
                        value: formValue?.gst_state?.value,
                        label: formValue?.gst_state?.label,
                    },
                    tds_declaration_form: attachments?.length > 0 ? attachments?.map((item) => {
                        return {
                            filename: item?.filename,
                            path: item?.path,
                        }
                    }) : [],
                };
                delete object._id;
                const res = await createSupplier(object);
                if (res?.responseCode == 200) {
                    setFormValue({});
                    setLoading(false);
                    toast.success('Supplier Updated Successfully');
                    if (shouldCloseModal) {
                        onClose();
                    } else {
                        setActiveTab(1);
                    }
                    callBackSupplier(res?.data?.supplier);
                } else {
                    setLoading(false);
                }
            } else {
                let object = {
                    ...formValue,
                    firm_id: formValue?.firm_id?.value ? formValue?.firm_id?.value : '',
                    message_lang: formValue?.message_lang?.value,
                    tds_deduction: isTds ? formValue?.tds_deduction?.value : 0,
                    gst_treatment_id: formValue?.gst_treatment_id?.value,
                    gst_state: {
                        value: formValue?.gst_state?.value,
                        label: formValue?.gst_state?.label,
                    },
                    tds_declaration_form: attachments?.length > 0 ? attachments?.map((item) => {
                        return {
                            filename: item?.filename,
                            path: item?.path,
                        }
                    }) : [],
                };
                const res = await createSupplier(object);
                if (res?.responseCode == 200) {
                    setLoading(false);
                    toast.success('Supplier Created Successfully');
                    if (shouldCloseModal) {
                        setFormValue({});
                        onClose();
                    } else {
                        setActiveTab(1);
                    }
                    callBackSupplier(res?.data?.supplier);
                } else {
                    setLoading(false);
                }
            }
        } catch (error) {
            setLoading(false);
        } finally {
            setIsButtonDisabled(false);
        }
    }

    const handleClick = async (e) => {
        e.preventDefault();
        if (activeTab === 3) {
            const validationResult = await utils?.checkFormError({ ...formValue, pan_mandatory: panPermission?.pan_mandatory, pan_validation: panPermission?.pan_validation, pan_attach_mandatory: panPermission?.pan_attach_mandatory }, errorSchema.addSupplierSchema);
            if (utils?.isObjectKeyEmpty(validationResult)) {
                setLoading(true);
                await apiCallingFunction(true);
                setFormError("");

            } else {
                setFormError(validationResult);
                setLoading(false);
            }
        } else {
            const validationResult = await utils?.checkFormError(formValue, errorSchema.addSupplierSchema);
            if (utils?.isObjectKeyEmpty(validationResult)) {
                setActiveTab(activeTab + 1);
            }

            setFormError(validationResult);
        }
    };

    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    const onhandleSelect = async (item, name) => {

        const stateObj = { ...formValue, [name]: item };
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.addSupplierSchema);
            if (validationResult === true) {
                setFormError({});
            } else {
                setFormError(validationResult);
            }
        }

    };

    const getAllDashboardData = async (data) => {
        const postData = {
            company_id: data,
            select_company_id: 1,
        };
        try {
            let response = await getDashbordData(postData);
            if (response?.responseCode === 200) {
                StorageService.setLocalItem("userData", JSON.stringify(response.data));
                setUserData(response.data);
            } else {
                throw response?.responseMessage;
            }
        } catch (error) {
            if (error?.name === "TypeError") {
                // Handle network errors, such as a failed fetch request
                console.error("Network error:", error?.responseMessage);
            } else {
                // Handle other errors, such as a bad response
                console.error("Error:", error?.responseMessage);
            }
        } finally {
        }
    };

    useEffect(() => {
        console.log(isOpen)
        if (!isOpen?._id) {
            // if (masterData?.gst_type_list?.length > 0 && states?.length > 0) {
            setFormValue((s) => ({
                ...s,
                as_of_date: utils?.getTodayDate(),
                gst_state: formValue?.state?.label ? {
                    label: formValue?.state?.label ? formValue?.state?.label : '',
                    value: formValue?.state?.value ? formValue?.state?.value : '',
                } : {},
                gst_treatment_id: masterData?.gst_type_list?.length > 0 ? masterData?.gst_type_list?.map((el) => {
                    return {
                        label: el?.name,
                        value: el?.id
                    }
                })[0] : { value: 1, label: "Unregistered Business" },
                tds_deduction: masterData?.tds_section_list?.length > 0 ? masterData?.tds_section_list?.map((el) => {
                    return {
                        label: el?.name,
                        value: el?.id
                    }
                })[0] : { value: 1, label: "1%" },
                company_id: StorageService.getCompanyId()
            }));
            // }
        }
    }, [masterData, StorageService.getCompanyId(), formValue?.state]);

    const changeActiveTab = async (event, value) => {
        event.preventDefault();
        if (value > activeTab) {
            const validationResult = await utils.checkFormError(formValue, errorSchema.addSupplierSchema);
            if (validationResult === true) {
                setActiveTab(value);
            } else {
                setFormError(validationResult);
            }
        } else {
            setActiveTab(value);
        }
    };

    const getStatesByApi = async (countryCode, stateCode) => {
        try {
            let data = {
                countryCode: countryCode ? countryCode : "IN",
                stateCode: stateCode ? stateCode : "",
            };
            let response = await getStatesData(data);
            if (response?.responseCode === 200) {
                if (countryCode && stateCode) {
                    setStateValue(response?.data[0]);
                    return response?.data[0];
                } else {
                    const optionsState = response?.data?.map((d) => {
                        return {
                            ...d,
                            label: d?.name,
                            value: d?.name
                        };
                    });

                    StorageService.setStates(JSON.stringify([...optionsState]))
                    setStates([...optionsState]);
                }
            } else {
                if (response) {
                    toast.error(response?.responseMessage)
                }
            }
        } catch (error) {
            toast.error("An unexpected error occurred. Please try again.");
        }
    };

    const getLanguageApi = async () => {
        try {
            let data = {
                is_master_view: 1, // for all 0
            }
            let response = await getLanguageData(data);
            if (response?.responseCode === 200) {
                let datas = response?.data?.map((el) => {
                    return {
                        ...el,
                        value: el?.iso_code
                    }
                })
                setLanguageArray(datas);
            }
        } catch (error) {
            toast.error("An unexpected error occurred. Please try again.")
        }
    }

    const handleCityChange = (data) => {
        handleOnChange("city", {
            label: data?.label,
            value: data?.name,
            lat: String(data?.latitude),
            long: String(data?.longitude)
        })

        getStatesByApi(data?.countryCode, data?.stateCode);

        // const stateDetails = State.getStateByCodeAndCountry(
        //     data?.stateCode,
        //     data?.countryCode
        // );
        // if (stateDetails?.name && stateDetails?.isoCode) {
        //     setStateValue(stateDetails)
        // }
    }

    useEffect(() => {
        if (stateValue?.name) {
            handleOnChange("state", {
                label: stateValue?.name, value: stateValue?.name, lat: String(stateValue?.latitude),
                long: String(stateValue?.longitude)
            })
        }
    }, [stateValue])

    const handleFileChange = async (event) => {
        const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg", "image/webp"];

        if (!allowedTypes.includes(event?.target?.files[0]?.type)) {
            event.target.value = "";
            toast.error("Only PDF and image files are allowed");
            return;
        }
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append("file", event?.target?.files[0]);
            const res = await uploadFiles(formData);
            if (res?.responseCode === 200) {
                if (event?.target.name === "pan_attachment") {
                    // setFormValue((prevData) => ({
                    //     ...prevData,
                    //     pan_image: res?.data?.path
                    // }))
                    handleOnChange("pan_image", res?.data?.path)
                    setPanAttacthment(res?.data)
                } else {
                    var fileArray = [...attachments]
                    fileArray.push(res?.data);
                    setAttachments(fileArray);
                }

                setLoading(false);
            } else {
                setLoading(false);
                event.target.value = "";
            }
        } catch (error) {
            setLoading(false);
            event.target.value = "";
        }
    }

    async function createFile(path) {
        setImageLoading(true)
        let response = await fetch(path);
        let data = await response.blob()
        let metadata = {
            type: 'image/jpeg'
        };
        let file = new File([data], "test.jpg", metadata);
        const formData = new FormData()
        // formData.append("logo", file)
        formData.append("file", file);

        if (formData) {
            const res = await uploadFiles(formData);
            if (res?.responseCode === 200) {
                handleOnChange("pan_image", res?.data?.path)
                setPanAttacthment(res?.data)
                setImageLoading(false)
                setIsModalOpen(false);
            }
        }
        setIsModalOpen(false);

    }

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleCropComplete = async (croppedImageUrl) => {
        setCroppedImage(croppedImageUrl);
        await createFile(croppedImageUrl)
    };

    const handleFilepanChange = (e) => {
        // const file = e.target.files?.[0];
        // if (!file) return;

        // const reader = new FileReader();
        // reader.onload = () => {
        //     if (typeof reader.result === "string") {
        //         setOriginalImage(reader.result);
        //         setIsModalOpen(true);
        //     }
        //     e.target.value = null;
        // };
        // reader.readAsDataURL(file);

        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            setImage(e.target.result);

            // Reset all values when new image is loaded
            setCrop({
                unit: 'px',
                x: 50,
                y: 50,
                width: 200,
                height: 200
            });
            setZoom(1);
            setRotation(0);
            setCompletedCrop(null);
            setPreviewImage(null);
            setOriginalImage(reader.result);
            setIsModalOpen(true);
        };
        reader.readAsDataURL(file);

    };


    const handleResetFormAndSubmit = async (e) => {
        e.preventDefault();
        setIsButtonDisabled(true); // Disable the button immediately
        const validationResult = await utils?.checkFormError({ ...formValue, pan_mandatory: panPermission?.pan_mandatory, pan_validation: panPermission?.pan_validation, pan_attach_mandatory: panPermission?.pan_attach_mandatory }, errorSchema.addSupplierSchema);

        if (activeTab === 3) {
            if (utils?.isObjectKeyEmpty(validationResult)) {
                setLoading(true);
                await apiCallingFunction(false); // Pass false to keep the modal open and reset the form
                setFormValue((prevData) => ({
                    ...prevData,
                    company_id: StorageService.getCompanyId(),
                    name: '',
                    contact_no: '',
                    opening_balance: '',
                    pay_type: 2,
                    as_of_date: getFormattedDate(),
                    address_line1: '',
                    // state: {},
                    // city: {},
                    pincode: '',
                    email_id: '',
                    alt_contact_no: '',
                    gst_no: '',
                    // gst_treatment_id: {},
                    // gst_state: {},
                    tds_declaration_form: [],
                    // tds_deduction: {},
                }))
                setFormError("");
            } else {
                setFormError(validationResult);
                setLoading(false);
                setIsButtonDisabled(false); // Re-enable the button if validation fails
            }
        } else {
            setActiveTab(activeTab + 1);
            setFormError(validationResult);
            setIsButtonDisabled(false); // Re-enable the button if validation fails
        }
    };

    useEffect(() => {
        if (isOpen?._id) {
            setFormValue((s) => ({
                ...s,
                firm_id: {
                    label: isOpen?.firm_id?.firm,
                    value: isOpen?.firm_id?._id
                },
               company_id: StorageService.getCompanyId(),
                name: isOpen?.name,
                contact_no: isOpen?.contact_no,
                opening_balance: isOpen?.opening_balance,
                pay_type: +isOpen?.pay_type,
                as_of_date: getFormattedDate(isOpen?.as_of_date),
                address_line1: isOpen?.address_line1,
                state: (isOpen?.state?.label && isOpen?.state?.value && isOpen?.state?.lat && isOpen?.state?.long) ? {
                    label: isOpen?.state?.label ? isOpen?.state?.label : '',
                    value: isOpen?.state?.value ? isOpen?.state?.value : '',
                    lat: isOpen?.state?.lat != 'undefined' ? isOpen?.state?.lat : '',
                    long: isOpen?.state?.long != 'undefined' ? isOpen?.state?.long : '',
                } : {},
                city: isOpen?.city,
                pincode: isOpen?.pincode,
                email_id: isOpen?.email,
                alt_contact_no: isOpen?.alt_contact_no,
                // gst_charges: +isOpen?.gst_charges,
                gst_no: isOpen?.gst_no ? isOpen?.gst_no : '',
                gst_treatment_id: isOpen?.gst_type ? masterData?.gst_type_list?.filter((element) => (element?.id === isOpen?.gst_type)).map((el) => {
                    return {
                        label: el?.name,
                        value: el?.id
                    }
                })[0] : masterData?.gst_type_list?.map((el) => {
                    return {
                        label: el?.name,
                        value: el?.id
                    }
                })[0],
                gst_state: isOpen?.gst_state?.label ? isOpen?.gst_state : {},
                pan_image: isOpen?.pan_image,
                pan_no: isOpen?.pan_no,
                tds_declaration_form: isOpen?.tds_declaration_form,
                tds_deduction: masterData?.tds_section_list?.filter((element) => (element?.id === isOpen?.tds_deduction)).map((el) => {
                    return {
                        label: el?.name,
                        value: el?.id
                    }
                })[0],
                message_lang: languageArray?.find((el) => el?.iso_code === isOpen?.message_lang),
                _id: isOpen?._id
            }))
            if (isOpen?.pan_image) {

                setPanAttacthment({ path: isOpen?.pan_image, filename: isOpen?.pan_image });
            }
            if (isOpen?.tds_declaration_form?.length > 0) {
                setIsAttachement(true);
                setAttachments(isOpen?.tds_declaration_form);
            }
            if (isOpen?.tds_deduction) {
                setIsTds(true)
            }
        }
    }, [isOpen, languageArray])

    useEffect(() => {
        if (formValue?.gst_treatment_id?.value === 1) {
            setFormValue((s) => ({
                ...s,
                gst_no: ''
            }))
        }
    }, [formValue?.gst_treatment_id])

    const addNewItemHandler = (e) => {

        setOpenLoction(true)
    }


    const callBackDataMaps = async (data) => {
        handleCityChange(data, "city")
        fetchFromCity()

    }

    let gmapLocates = {
        isOpen: openLoction,
        closeModal: (e) => setOpenLoction(false),
        modalMainClass: "_dashCommon_Modal _mdModalLoction",
        modalTitle: 'Add Location',
        submitTitle: 'Add Location',
        callBackDataMap: callBackDataMaps
    };

    const handleDeleteFileFunction = (path) => {
        let images = [...attachments];
        let newArray = images.filter((el) => el?.path != path)
        setAttachments(newArray)
    }

    const documentRemove = async (path, value = false) => {
        setIsDelete(path);
        setCanPanImageEmpty(value);
    };

    const submitDeleteSupplier = async () => {
        setLoadingDelete(true);
        try {
            const payload = {
                file_path: isDelete
            }

            const res = await deleteImage(payload)

            if (res?.responseCode === 200) {
                setLoadingDelete(false);
                if (canPanImageEmpty) {
                    setFormValue((s) => ({
                        ...s,
                        pan_image: ""
                    }))
                    setPanAttacthment({})
                } else {
                    handleDeleteFileFunction(isDelete);
                }
                toast.success(res?.responseMessage)
                setIsDelete(false)
            } else {
                setIsDelete(false)
                setLoadingDelete(false);
                toast.error(res?.responseMessage)
            }
        } catch (error) {
            setLoadingDelete(false)
        }
    }

    let propsObject = {
        isOpen: isDelete,
        closeModal: () => setIsDelete(false),
        modalTitle: "Confirmation",
        submitTitle: "Confirm",
        cancleTitle: "Close",
        onSubmit: submitDeleteSupplier,
        isLoadding: loadingDelete,
    }
    const imageProps = {
        setIsModalOpen,
        isModalOpen,
        image,
        setImage,
        crop,
        setCrop,
        zoom,
        setZoom,
        rotation,
        setRotation,
        completedCrop,
        setCompletedCrop,
        showPreview,
        setShowPreview,
        previewImage,
        setPreviewImage,
        handleCropComplete,
        imageLoading
    };

    const getDataFirmList = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
            }
            const res = await getUserFirm(object);
            if (res?.responseCode == 200) {
                let apiData = res?.data?.firm_list?.map((el) => {
                    return {
                        label: el?.firm_id?.firm,
                        value: el?.firm_id?._id,
                    }
                })
                setFirmDataList(apiData);
                if (!isOpen?._id) {
                    if (apiData?.length === 1) {
                        setFormValue((s) => ({
                            ...s,
                            firm_id: apiData[0]
                        }))
                    } else {
                        setFormValue((s) => ({
                            ...s,
                            firm_id: {}
                        }))
                    }
                }
            }
        } catch (error) {
        }
    }

    useEffect(() => {
        getStatesByApi();
        getAllDashboardData(StorageService?.getCompanyId())
        getLanguageApi();
        getDataFirmList();
    }, [])

    // useEffect(() => {
    //     if (firmDataList?.length > 0 && !isOpen?._id) {
    //         let findObject = firmDataList?.find((el) => el?.value === StorageService.getFirmId());
    //         setFormValue((s) => ({
    //             ...s,
    //             firm_id: findObject?.value ? findObject : {}
    //         }))
    //     }
    // }, [StorageService.getFirmId(), firmDataList, isOpen])

    useEffect(() => {

        if (firmDataList?.length > 0 && !isOpen?._id) {
            const storageFirmId = StorageService.getFirmId();

            let findObject = firmDataList.find((el) => el?.value === storageFirmId);

            const branchFirm = branchFirmId?._id;
            let vehicleFirmObject = firmDataList.find((el) => el?.value === branchFirm);

            setFormValue((s) => ({
                ...s,
                ...(vehicleFirmObject ? { firm_id: vehicleFirmObject } : findObject ? { firm_id: findObject } : {})
            }));
        }
    }, [StorageService.getFirmId(), firmDataList, isOpen?._id, branchFirmId]);

    let storeModelProps = {
        isOpen: imagePreview,
        modalMainClass: '_dashCommon_Modal _mdModal',
        modalTitle: 'Preview',
        submitTitle: 'Preview',
        footerPart: true,
        hideFooterSumbmitBtn: true,
        hideCompletelyFoolter: true,
        modalZIndex: 999999,
        closeModal: (e) => setImagePreview(false),
    }

    const youtubeProps = {
        isOpen: youtubeVideos,
        closeModal: () => setYoutubeVideos((s) => ({ ...s, moduleName: '', moduleAction: false })),
        headerPart: false,
        modalTitle: `Add Supplier`,
        submitTitle: `Add Supplier`,
        modalMainClass: "_mdModal",
        videosModuleName: constant.Key.supplier,
    }

    return (
        <div>
            <div
                className={`offcanvas offcanvas-end common_offCanvas ${isOpen ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: isOpen ? 'visible' : 'hidden', zIndex: imagePreview && 9 }}
            >
                <div className={formValue?.firm_id?.label ? `offcanvas-header offcan_header` : `offcanvas-header`}>
                    {formValue?.firm_id?.label ?
                        <div>
                            <h5 className="offcanvas-title">{isOpen?._id ? 'Update Supplier' : 'Add Supplier'}</h5>
                            <p className='offcanvas_heading_head'>
                                <img src={FirmImg} className='firm_icon_img' /> {" "}
                                {formValue?.firm_id?.label ? formValue?.firm_id?.label : <Link to='/setting/firm'> Create Firm </Link>}
                            </p>
                        </div>
                        :
                        <h5 className="offcanvas-title">{isOpen?._id ? 'Update Supplier' : 'Add Supplier'}</h5>
                    }

                    <div className="flxs_lr_cls">
                        {!isOpen?._id && (
                            <div className="youtube_Icon" onClick={(e) => setYoutubeVideos((s) => ({ ...s, moduleName: 'supplier_creation', moduleAction: true }))}>
                                <button><FaYoutube size={36} /></button>
                            </div>
                        )}
                        <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={() => onClose(!isOpen)}>
                            <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none" >
                                <path
                                    d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                                    fill="black" />
                            </svg>
                        </CrossButton>
                    </div>
                </div>

                <div className="offcanvas-body">
                    <div className='pr_procssBx'>
                        <div className='pr_procssBx_grid'>
                            {!isOpen?._id && firmDataList?.length > 1 && <div className='singleDiv'>
                                <CustomSelect
                                    options={firmDataList}
                                    label="Select Firm"
                                    placeholder="Select Firm"
                                    name="firm_id"
                                    value={formValue?.firm_id}
                                    error={formError["firm_id.label"]}
                                    disabled={hideAddNewOption ? false : (formValue?.firm_id?.value ? true : false)}
                                    onSelect={(data) => onhandleSelect(data, 'firm_id')}
                                />
                            </div>}

                            <div className='singleDiv'>
                                <CommonInput
                                    type="text"
                                    placeholder="Supplier Name"
                                    label="Supplier Name *"
                                    name='name'
                                    value={formValue.name}
                                    focus={!!(typeof formError === "object" && formError?.name)}
                                    error={!!(typeof formError === "object") ? formError?.name : ""}
                                    // onChange={({ target: { name, value } }) =>
                                    //     handleOnChange(name, value)
                                    // }
                                    maxLength="30"
                                    onInput={utils.maxLengthCheck}
                                    onChange={(e) => utils.handleNameInputChange(e, handleOnChange)}

                                />
                            </div>

                            <div className='singleDiv'>
                                <CommonInput
                                    type="text"
                                    placeholder="Mobile Number"
                                    label='Mobile Number'
                                    name='contact_no'
                                    maxLength="16"
                                    onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                    // onInput={maxLengthCheck}
                                    value={formValue.contact_no}
                                    focus={!!(typeof formError === "object" && formError?.contact_no)}
                                    error={!!(typeof formError === "object") ? formError?.contact_no : ""}
                                    onChange={(e) => utils.handleMobileInputChange(e, handleOnChange)}

                                />
                            </div>

                            <div className='halfDiv'>
                                <CommonInput
                                    type="text"
                                    placeholder="Opening Balance (₹)"
                                    label="Opening Balance (₹)"
                                    name='opening_balance'
                                    maxLength="15"
                                    onInput={maxLengthCheck}
                                    value={formValue.opening_balance}
                                    focus={!!(typeof formError === "object" && formError?.opening_balance)}
                                    error={!!(typeof formError === "object") ? formError?.opening_balance : ""}
                                    onChange={(e) => utils.handleOpeningBalanceInputChange(e, handleOnChange)}

                                />
                            </div>

                            <div className='halfDiv'>
                                <CommonInput
                                    type="date"
                                    placeholder="As of Date * "
                                    label="As of Date * "
                                    name='as_of_date'
                                    onKeyDown={(e) => e.preventDefault()}
                                    value={formValue.as_of_date}
                                    focus={!!(typeof formError === "object" && formError?.as_of_date)}
                                    error={!!(typeof formError === "object") ? formError?.as_of_date : ""}
                                    onChange={({ target: { name, value } }) =>
                                        handleOnChange(name, value)
                                    }
                                />
                            </div>
                        </div>

                        <div className='checkBx_lv mt-2'>
                            {
                                constant.Receive_Pay?.map((el, ind) => {
                                    return (
                                        <React.Fragment>
                                            <input
                                                className="form-check-input"
                                                id={+ind + "pay_type" + el?.value}
                                                type="radio"
                                                name="pay_type"
                                                checked={Number(formValue?.pay_type) === Number(el?.value)}
                                                value={formValue?.pay_type ? formValue?.pay_type : ""}
                                                onChange={({ target: { name, value } }) =>
                                                    handleOnChange(name, +el?.value)
                                                }
                                            />
                                            <label htmlFor={+ind + "pay_type" + el.value} className="form-check-label" >
                                                {el.label}
                                            </label> &nbsp;
                                        </React.Fragment>
                                    )
                                })
                            }
                        </div>
                    </div>

                    <div className='addPr_flBx __newTabs_bx'>
                        <ul className="nav nav-tabs cstNew_tabs" id="addParty" role="tablist">
                            {constant.addPartyTabs?.map((item, indx) => (
                                <li
                                    className="nav-item"
                                    role="presentation"
                                    key={indx + item?.value}
                                >
                                    <button
                                        className={
                                            "nav-link " + (activeTab === item?.id ? "active" : "")
                                        }
                                        type="button"
                                        aria-selected={activeTab === item?.id}
                                        onClick={(e, val) => changeActiveTab(e, item.id)}
                                    >
                                        {item?.title}
                                    </button>
                                </li>
                            ))}
                        </ul>

                        {activeTab === 1 && (
                            <div className='pr_procssBx' id="addPartyContent">
                                <div className='pr_procssBx_grid'>

                                    <div className='singleDiv'>
                                        <div className="h4Head">Add Address</div>
                                    </div>

                                    <div className='singleDiv'>
                                        <CommonInput
                                            type="text"
                                            placeholder="Address Line 1"
                                            label="Address Line 1"
                                            name='address_line1'
                                            value={formValue.address_line1}
                                            focus={!!(typeof formError === "object" && formError?.address_line1)}
                                            error={!!(typeof formError === "object") ? formError?.address_line1 : ""}
                                            onChange={({ target: { name, value } }) =>
                                                handleOnChange(name, value)
                                            }
                                        />
                                    </div>

                                    <div className='singleDiv'>

                                        <CityDropdownForTrip
                                            key={`fromLoction`}
                                            label="City "
                                            placeholder="Select a city"
                                            fetchData={fetchFromCity}
                                            isAddButton={true}
                                            addButtonAction={(e) => addNewItemHandler(e)}
                                            pageSize={20}
                                            onChange={(data) => handleCityChange(data, "city")}

                                            selectedItem={formValue?.city}
                                            error={!!formError["city.label"]}
                                            errorMessage={
                                                formError["city.label"]
                                            }
                                            withState={false}
                                        />
                                    </div>

                                    <div className='halfDiv'>
                                        <CommonInput
                                            type="text"
                                            placeholder="State"
                                            label="State"
                                            name='state'
                                            disabled={true}
                                            value={formValue?.state?.label}
                                            focus={!!(typeof formError === "object" && formError?.state)}
                                            error={!!(typeof formError === "object") ? formError?.state : ""}
                                            onChange={({ target: { name, value } }) =>
                                                handleOnChange(name, value)
                                            }
                                        />
                                    </div>

                                    <div className='halfDiv'>
                                        <CommonInput
                                            type="text"
                                            placeholder="PIN Code"
                                            label="PIN Code"
                                            name="pincode"
                                            maxLength={6}

                                            value={formValue.pincode}
                                            focus={!!(typeof formError === "object" && formError?.pincode)}
                                            error={!!(typeof formError === "object") ? formError?.pincode : ""}
                                            onChange={({ target: { name, value } }) => {
                                                if (/^\d*$/.test(value)) {
                                                    handleOnChange(name, value);
                                                    // setPhoneError("");
                                                }
                                            }}
                                        />
                                    </div>

                                    <div className='singleDiv'>
                                        <div className="h4Head">Other Contact</div>
                                    </div>

                                    <div className='singleDiv'>
                                        <CommonInput
                                            type="text"
                                            placeholder="Alternate Number"
                                            label="Alternate Number"
                                            name='alt_contact_no'
                                            maxLength="16"
                                            // onInput={maxLengthCheck}
                                            value={formValue.alt_contact_no}
                                            focus={!!(typeof formError === "object" && formError?.alt_contact_no)}
                                            error={!!(typeof formError === "object") ? formError?.alt_contact_no : ""}
                                            // onChange={({ target: { name, value } }) =>
                                            //     handleOnChange(name, value)
                                            // }
                                            onInput={utils.maxLengthCheck}
                                            onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                            onChange={(e) => utils.handleMobileInputChange(e, handleOnChange)}
                                        />
                                    </div>

                                    <div className='singleDiv'>
                                        <CommonInput
                                            type="Email"
                                            placeholder="Email ID"
                                            label='Email ID'
                                            name='email_id'
                                            maxLength="50"
                                            onInput={utils.maxLengthCheck}
                                            value={formValue.email_id}
                                            focus={!!(typeof formError === "object" && formError?.email_id)}
                                            error={!!(typeof formError === "object") ? formError?.email_id : ""}
                                            onChange={({ target: { name, value } }) =>
                                                handleOnChange(name, value)
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {activeTab === 2 && (
                            <div className='pr_procssBx' id="addPartyContent">
                                <div className='pr_procssBx_grid'>
                                    <div className='singleDiv'>
                                        <CustomSelect
                                            options={masterData?.gst_type_list?.map((el) => {
                                                return {
                                                    label: el?.name,
                                                    value: el?.id
                                                }
                                            })}
                                            name="gst_treatment_id"
                                            label="GST Type"
                                            value={formValue?.gst_treatment_id}
                                            error={formError["gst_treatment_id.label"]}
                                            onSelect={(data) => onhandleSelect(data, 'gst_treatment_id')}
                                            placeholder="Select GST Type"
                                        />
                                    </div>

                                    {
                                        (formValue?.gst_treatment_id?.value == '2' || formValue?.gst_treatment_id?.value == '3') && (
                                            <div className='singleDiv'>
                                                <CommonInput
                                                    type="text"
                                                    placeholder="GST Number e.g. 09AAACH7409R1RR"
                                                    label='GST Number'
                                                    name='gst_no'
                                                    maxLength={15}
                                                    value={formValue.gst_no}
                                                    onChange={({ target: { name, value } }) =>
                                                        handleOnChange(name, value.toUpperCase())
                                                    }
                                                    focus={!!(typeof formError === "object" && formError?.gst_no)}
                                                    error={!!(typeof formError === "object") ? formError?.gst_no : ""}
                                                />

                                            </div>
                                        )
                                    }

                                    <div className='singleDiv'>
                                        <CustomSelect
                                            options={states}
                                            name="gst_state"
                                            label="GST State"
                                            value={formValue?.gst_state}
                                            error={formError["gst_state.label"]}
                                            onSelect={(data) => onhandleSelect(data, 'gst_state')}
                                            placeholder="Select GST State"
                                        />
                                    </div>

                                </div>
                            </div>
                        )}

                        {activeTab === 3 && (
                            <div className='pr_procssBx' id="addPartyContent">
                                <div className='pr_procssBx_grid'>
                                    <div className='singleDiv'>
                                        <div className="form-check form-switch">
                                            <label className="form-check-label" htmlFor="tds_declaration_form"> TDS Declaration form </label>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="tds_declaration_form"
                                                checked={isAttachement}
                                                onChange={(e) => setIsAttachement(!isAttachement)}
                                            />
                                        </div>
                                        {
                                            isAttachement && (
                                                <div className='mt-3'>

                                                    <label className="attachFilelabel">
                                                        <span className="title"> + Attach Form </span>
                                                        <input
                                                            className="FileUpload1"
                                                            name="booking_attachment"
                                                            id="file-input"
                                                            onChange={(e) => handleFileChange(e)}
                                                            type="file"
                                                            disabled={attachments?.length >= 5}
                                                            multiple
                                                        />
                                                    </label>

                                                    {attachments?.length > 0 ? attachments?.map((file, index) => (
                                                        < div className='img_fnex_src' key={index} >
                                                            <div className='__upFileDetail'>
                                                                <div className='__uplImg'>

                                                                    {
                                                                        file?.path?.split('.')?.at(-1) === 'pdf' ?
                                                                            <span className='pdf_clsr-ct'>
                                                                                <BsFillFileEarmarkPdfFill />
                                                                            </span>
                                                                            : (file?.path?.split('.')?.at(-1) === 'xlsx' || file?.path?.split('.')?.at(-1) === 'xls' || file?.path?.split('.')?.at(-1) === 'txt') ?
                                                                                <span className='xlsx_clsr-ct'>
                                                                                    <BsFiletypeXlsx />
                                                                                </span> :
                                                                                <span className='__uplImg-ct'>
                                                                                    <FaRegImage />
                                                                                </span>
                                                                    }
                                                                    <p>{`${file?.filename}`}</p>
                                                                </div>
                                                                <div className='__uplIcons _avPointer'>
                                                                    {
                                                                        !(file?.path?.split('.')?.at(-1) === 'pdf' || file?.path?.split('.')?.at(-1) === 'xlsx' || file?.path?.split('.')?.at(-1) === 'xls' || file?.path?.split('.')?.at(-1) === 'txt') &&
                                                                        <MdOutlineRemoveRedEye onClick={() => setImagePreview({ url: `${masterData?.s3_url}${file?.path}`, preview: true })} style={{ fontSize: '18px', color: 'blue' }} />
                                                                    }

                                                                    <a href={`${masterData?.s3_url}${file?.path}`} target='_blank' className='__upDownload_ico' style={{ fontSize: '18px' }}>
                                                                        <MdOutlineFileDownload />
                                                                    </a>
                                                                    <span className='__upCross_ico' style={{ fontSize: '18px' }} onClick={(e) => documentRemove(file?.path, false)}>
                                                                        <RxCross2 />
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )) : <></>}
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div className='singleDiv'>
                                        <CommonInput
                                            type="text"
                                            placeholder="PAN Number"
                                            label='PAN Number'
                                            name='pan_no'
                                            maxLength={10}
                                            value={formValue.pan_no}
                                            focus={!!(typeof formError === "object" && formError?.pan_no)}
                                            error={!!(typeof formError === "object") ? formError?.pan_no : ""}
                                            onChange={({ target: { name, value } }) =>
                                                handleOnChange(name, value.toUpperCase())
                                            }
                                        />
                                        <ImageCropperModal {...imageProps} />
                                        {

                                            <div className='mt-3'>

                                                <label className="attachFilelabel">
                                                    <span className="title"> + Attach PAN Image </span>
                                                    <input
                                                        className="FileUpload1"
                                                        name="pan_attachment"
                                                        id="file-input"
                                                        onChange={(e) => handleFilepanChange(e)}
                                                        type="file"
                                                        accept="image/*"
                                                    // multiple
                                                    />
                                                </label>
                                                {formError?.pan_image && (
                                                    <span className="input_drop_error">
                                                        {formError?.pan_image}
                                                    </span>
                                                )}

                                                {/* {panAttacthment && <a className="p_colored pan_image">
                                                    <img src={`${masterData?.s3_url}${formValue?.pan_image}`} />
                                                    <span className="_panDel_icon">
                                                        <IoCloseCircle
                                                            onClick={() => documentRemove(formValue?.pan_image)}
                                                        />
                                                    </span>
                                                </a>} */}

                                                {panAttacthment?.path && <div className='img_fnex_src'>
                                                    <div className='__upFileDetail'>
                                                        <div className='__uplImg'>

                                                            {
                                                                panAttacthment?.path?.split('.')?.at(-1) === 'pdf' ?
                                                                    <span className='pdf_clsr-ct'>
                                                                        <BsFillFileEarmarkPdfFill />
                                                                    </span>
                                                                    : (panAttacthment?.path?.split('.')?.at(-1) === 'xlsx' || panAttacthment?.path?.split('.')?.at(-1) === 'xls' || panAttacthment?.path?.split('.')?.at(-1) === 'txt') ?
                                                                        <span className='xlsx_clsr-ct'>
                                                                            <BsFiletypeXlsx />
                                                                        </span> :
                                                                        <span className='__uplImg-ct'>
                                                                            <FaRegImage />
                                                                        </span>
                                                            }
                                                            <p>{`${panAttacthment?.filename}`}</p>
                                                        </div>
                                                        <div className='__uplIcons _avPointer'>
                                                            {/* <a href={`${masterData?.s3_url}${panAttacthment?.path}`} target='_blank' className='__upEye_ico' style={{ fontSize: '18px' }}>
                                                                <MdOutlineRemoveRedEye />
                                                            </a> */}

                                                            <MdOutlineRemoveRedEye onClick={() => setImagePreview({ url: `${masterData?.s3_url}${panAttacthment?.path}`, preview: true })} style={{ fontSize: '18px', color: 'blue' }} />

                                                            <a href={`${masterData?.s3_url}${panAttacthment?.path}`} target='_blank' className='__upDownload_ico' style={{ fontSize: '18px' }}>
                                                                <MdOutlineFileDownload />
                                                            </a>
                                                            <span className='__upCross_ico' style={{ fontSize: '18px' }} onClick={(e) => documentRemove(panAttacthment?.path, true)}>
                                                                <RxCross2 />
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>}
                                            </div>

                                        }
                                    </div>
                                    <div className='singleDiv'>
                                        <div className="form-check form-switch">
                                            <label className="form-check-label" htmlFor="tds_deduction"> TDS Applicable </label>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="tds_deduction"
                                                checked={isTds}
                                                onChange={(e) => setIsTds(!isTds)}
                                            />
                                        </div>
                                        {
                                            isTds && (
                                                <div className='singleDiv mt-3'>
                                                    <CustomSelect
                                                        options={masterData?.tds_section_list?.map((el) => {
                                                            return {
                                                                label: el?.name,
                                                                value: el?.id
                                                            }
                                                        })}
                                                        name="tds_deduction"
                                                        label="TDS Percentage"
                                                        value={formValue?.tds_deduction}
                                                        placeholder="Select TDS Percentage"
                                                        error={formError["tds_deduction.label"]}
                                                        // focus={!!(typeof formError === "object" && formError?.tds_deduction)}
                                                        // error={!!(typeof formError === "object") ? formError?.tds_deduction : ""}
                                                        onSelect={(data) => onhandleSelect(data, 'tds_deduction')}
                                                    />
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div className='singleDiv'>
                                        <CustomSelect
                                            options={languageArray}
                                            name="message_lang"
                                            label="Message Language"
                                            value={formValue?.message_lang}
                                            placeholder="Select Language"
                                            onSelect={(data) => onhandleSelect(data, 'message_lang')}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>

                </div>

                <div className='offcanvas-footer'>
                    {
                        (activeTab === 3) ? (
                            <React.Fragment>
                                <AddButton onClick={(e) => handleClick(e)} disabled={loading} name={loading ? 'Loading...' : (isOpen?._id ? 'Update & Save' : 'Add Supplier')} />
                                {!isOpen?._id ? <button
                                    className={isButtonDisabled ? '_addNewComm_btn_disabled' : '_addNewComm_btn'}
                                    onClick={handleResetFormAndSubmit}
                                    disabled={isButtonDisabled || loading}

                                >
                                    Add & New
                                </button> : <></>}
                            </React.Fragment>
                        ) : (activeTab === 2 ? (
                            <AddButton onClick={(e) => handleClick(e)} name='Continue' />
                        ) : (
                            <AddButton onClick={(e) => handleClick(e)} disabled={!formValue?.name || !formValue?.as_of_date} name='Continue' />
                        ))
                    }

                </div>
            </div>
            {openLoction && <AddLocationModal {...gmapLocates} />}
            {
                isDelete && (
                    <CommonModal {...propsObject}>
                        <p className='p-3'> Are you sure you want to delete ?</p>
                    </CommonModal>
                )
            }

            {
                imagePreview?.preview
                && (
                    <ImagePreview {...storeModelProps} />
                )
            }

            {
                (youtubeVideos?.moduleName === 'supplier_creation' && youtubeVideos?.moduleAction === true)
                && (
                    <YoutubeModal {...youtubeProps} />
                )
            }

            {/* <ImageCropModal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                onCrop={handleCropComplete}
                imageSrc={originalImage}
                imageLoading={imageLoading}
            /> */}
        </div >
    )
}

export default AddEditSupplier
